import Home from '../Pages/Home/Home';
import Profile from '../Pages/Settings/Profile/Profile';
import Settings from '../Pages/Settings/Settings';
import UserAccess from '../Pages/Settings/UserAccess/UserAccess';
import Developers from '../Pages/Settings/Developers/Developers';
import Workspaces from '../Pages/Workspaces/Workspaces';
import Notifications from '../Pages/Notifications/Notifications';
import Dashboard from '../Pages/Dashboard/Dashboard';
import Build from '../Pages/Build/Build';
import BuildQuickActionFrom from '../Pages/Build/From/From';
import Play from '../Pages/Play/Play';
import RoleAndPermission from '../Pages/Settings/SuperAdmin/RoleAndPermission/RoleAndPermission';
import Resources from '../Pages/Resources/Resources';
import CreateResource from '../Pages/Resources/CreateNewResource/CreateResource';
import Resource from '../Pages/Settings/Resources/Resource';
import Billing from '../Pages/Settings/Billing/Billing';
import EditForm from '../Pages/Build/From/EditForm/EditForm';
import NewBuild from '../Pages/NewBuild/NewBuild';

const Pages = [
    {
        path: '',
        element: <Home />,
    },
    {
        path: 'dashboard',
        element: <Dashboard />,
    },
    {
        path: 'build',
        element: <Build />,
    },
    {
        path: 'build-quick-action/:workspaceById?/:folderById?',
        element: <BuildQuickActionFrom />,
    },
    {
        path: 'edit-quick-action/:id',
        element: <EditForm />,
    },
    {
        path: 'play',
        element: <Play />,
    },
    {
        path: 'workspaces/*',
        element: <Workspaces />,
    },
    {
        path: 'notifications',
        element: <Notifications />,
    },
    {
        path: 'settings',
        element: <Settings />,
        children: [
            {
                path: '',
                element: <Profile />,
            },
            {
                path: 'userAccess',
                element: <UserAccess />,
            },
            {
                path: 'developers',
                element: <Developers />,
            },
            {
                path: 'resourceNew',
                element: <Resource />,
            },
            {
                path: 'billing',
                element: <Billing />,
            },
        ],
    },
    {
        path: 'role-permission',
        element: <RoleAndPermission />,
    },
    {
        path: 'get_started',
        element: <Resources />,
    },
    {
        path: 'createResource',
        element: <CreateResource />,
    },
];

export default Pages;
